<div id="petl" class="petl" #petl>
    <div class="menu">
        <button class="about icon" title="About PETL" [class.selected]="currentView === 'about'"
            (click)="toggleView('about')">
            <span class="icon icon-ui-description"></span>
        </button>
        <button class="manage-projects icon" title="Manage Projects"
            [class.selected]="currentView === 'manage-projects'" (click)="toggleView('manage-projects')">
            <span class="icon icon-ui-layer-list"></span>
        </button>
        <div class="steps-container">
            <div class="steps">
                <button (click)="changeView('start')" [class.selected]="currentView === 'start'">
                    <span class="icon icon-ui-upload"></span>
                    <span class="menu-title">1- File Upload</span>
                </button>
                <div class="arrow-right">
                    <span class="icon icon-ui-right"></span>
                </div>
                <button (click)="changeView('processor')" [class.selected]="currentView === 'processor'"
                    [disabled]="isColumnMappingButtonDisabled" [class.disabled]="isColumnMappingButtonDisabled">
                    <span class="icon icon-ui-table"></span>
                    <span class="menu-title">2 - Column Mapping</span>
                </button>
                <div class="arrow-right">
                    <span class="icon icon-ui-right"></span>
                </div>
                <button (click)="changeView('validate')" [class.selected]="currentView === 'validate'"
                    [disabled]="isValidationButtonDisabled" [class.disabled]="isValidationButtonDisabled">
                    <span class="icon icon-ui-review"></span>
                    <span class="menu-title">3 - Validation</span>
                </button>
                <div class="arrow-right">
                    <span class="icon icon-ui-right"></span>
                </div>
                <button (click)="changeView('promoted')" [class.selected]="currentView === 'promoted'"
                    [disabled]="isPromotedButtonDisabled" [class.disabled]="isPromotedButtonDisabled">
                    <span class="icon icon-ui-maps"></span>
                    <span class="menu-title">4 - Promoted</span>
                </button>
            </div>
        </div>
    </div>
    <mc-petl-about-ng id="petlAbout" *ngIf="currentView === 'about'" #petlAbout></mc-petl-about-ng>
    <mc-petl-manage-projects-ng id="petlManageProjects" *ngIf="currentView === 'manage-projects'" #petlManageProjects>
    </mc-petl-manage-projects-ng>
    <mc-petl-start-ng id="petlStart" *ngIf="currentView === 'start'" #petlStart></mc-petl-start-ng>
    <mc-petl-processor-ng id="petlProcessor" *ngIf="currentView === 'processor'" #processor></mc-petl-processor-ng>
    <mc-petl-validate-ng id="petlValidate" *ngIf="currentView === 'validate'" #validate></mc-petl-validate-ng>
    <mc-petl-promoted-ng id="petlPromoted" *ngIf="currentView === 'promoted'" #promoted></mc-petl-promoted-ng>
    <div class="loader is-active padding-leader-3 padding-trailer-3" *ngIf="loading">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
    <div *ngIf="errorMessage" class="error-message" (click)="clearError()"> {{ errorMessage }} </div>
</div>